import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {UserDocumentComponent} from '../user-document/user-document.component';
import {UserDocumentResolver} from '../resolvers/user-document-resolver';
import {UserDocumentViewComponent} from './user-document-view.component';

const routes: Routes = [
  {
    path: '',
    component: UserDocumentViewComponent,
    children: [

      {
        path: ':userDocumentId',
        component: UserDocumentComponent,
        data: {
          relativeBackLink: '../..'
        },
        resolve: {
          userDocument: UserDocumentResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserDocumentViewRoutingModule {
}
